export default __webpack_public_path__ + "static/media/check.61f2e35b.svg";